import { render, staticRenderFns } from "./file-pdf.vue?vue&type=template&id=dffe7f00"
import script from "./file-pdf.vue?vue&type=script&lang=js"
export * from "./file-pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports